import { Drawer } from '../../molecules/drawer/Drawer';
import styles from './MiniCart.module.scss';
import DesktopMinicart from './desktopMinicart/DesktopMinicart';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { useIsomorphicLayoutEffect } from 'react-use';
import app from '@frontastic/catwalk/src/js/app/app';
import { useScrollLock } from '../../../utils/useLockScroll';

import { Link } from '../../atoms/link/Link';
import { useCartContext } from '../../../provider/cart/CartContext';
import { useSelector } from 'react-redux';
import { useGlobalSettings } from '../../../utils/useGlobalSettings';
import { getCurrentLocale } from '../../../utils/getCurrentLocale';

const MiniCart = React.forwardRef(
  (
    { showDialog, data, items, loggedIn, cart, shippingCoastMessage, promo, nostoBlocks, customerGroupId },
    ref,
  ) => {
    const { setShowCart } = useCartContext();
    const showSearchDropdown = useSelector(
      (state) => state['demo-ui'].showSearchDropdown,
    );

    const currentSiteRegion = getCurrentLocale();
    const { vipDiscount } = useGlobalSettings({ locale: currentSiteRegion });

    const firstOrderMessage = promo || `Sign Up for ${vipDiscount}% off your first order`;
    const noProductsMessage = 'Add items to proceed to checkout';

    const bagsQuantityArray = [];
    data.lineItems &&
      data.lineItems.forEach((element) => {
        bagsQuantityArray.push(element.count);
      });

    const bagsQuantity = bagsQuantityArray.reduce((sum, current) => {
      return sum + current;
    }, 0);

    const startModalWidth = 392;

    const [isMounted, setIsMounted] = useState(false);

    const contentRef = useRef(null);

    const onClickTitle = async () => {
      await setShowCart(false);
      await app.getRouter().push('Frontastic.Frontend.Master.Checkout.cart');
    };

    useIsomorphicLayoutEffect(() => {
      setIsMounted(true);
      if (!isMounted || !contentRef.current) return;
    });

    useEffect(() => {
      if (!isMounted || !contentRef.current) return;
    }, [contentRef, isMounted]);

    if (!data) return null;

    useScrollLock(showDialog && !showSearchDropdown);

    return (
      <div className={styles.root} ref={ref}>
        {showDialog && (
          <Drawer
            onClose={() => {
              setTimeout(() => setShowCart(false), 500);
            }}
            shown={showDialog}
            width={startModalWidth}
            position="right"
            customClasses={{
              header: styles.header,
              aside: styles.aside,
              content: styles.content,
            }}
            title={
              <Link onClick={onClickTitle}>
                <span
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                  }}
                >
                  Your Bag:
                  <span>({bagsQuantity})</span>
                </span>
              </Link>
            }
          >
            <DesktopMinicart
              data={data}
              loggedIn={loggedIn}
              items={items}
              cart={cart}
              firstOrderMessage={firstOrderMessage}
              noProductsMessage={noProductsMessage}
              shippingCoastMessage={shippingCoastMessage}
              bagsQuantity={bagsQuantity}
              nostoBlocks={nostoBlocks}
              customerGroupId={customerGroupId}
            />
          </Drawer>
        )}
      </div>
    );
  },
);

MiniCart.propTypes = {
  showDialog: PropTypes.bool,
  headerHeight: PropTypes.string,
};

MiniCart.defaultProps = {
  showDialog: false,
  headerHeight: '0',
};

export default MiniCart;
